export default "__VITE_ASSET__D3Lbr_v4__"